import React from "react";
import { useNavigate } from "react-router-dom";

/* eslint-disable @typescript-eslint/ban-types */
interface SidebarProps {
  text: string;
  img: string;
  redirect: () => void;
  centered: boolean;
  disabled: boolean;
  minimized: boolean;
}
/* eslint-enable @typescript-eslint/ban-types */

const SidebarElement: React.FC<SidebarProps> = ({
  text,
  img,
  redirect,
  centered,
  disabled,
  minimized,
}) => {
  const [isHovered, setIsHovered] = React.useState(false);

  const navigateToRedirect = () => {
    if (!disabled) {
      redirect();
    }
  };

  const notHovered = () => {
    setIsHovered(false);
  };

  const hovered = () => {
    setIsHovered(true);
  };

  return (
    <div
      className={`mt-2 flex flex-row ${
        centered ? "justify-start" : "justify-end"
      } `}
    >
      {centered && (
        <button onClick={navigateToRedirect}>
          <img
            src={img}
            alt={text}
            className={`mb-2 mr-4 h-8 w-8 md:h-16 md:w-16 ${
              isHovered && disabled == false
                ? "industry-img-selected"
                : "industry-img"
            }`}
            onMouseEnter={hovered}
            onMouseLeave={notHovered}
          />
        </button>
      )}
      {disabled && !minimized && (
        <div className="my-auto flex flex-col">
          <h1
            className={`mr-4 font-code xl:text-lg ${
              centered ? "text-left" : "text-right"
            } text-[#828282]`}
          >
            {text}{" "}
          </h1>
          <p className="font-code text-xs text-[#828282]">
            (under construction)
          </p>
        </div>
      )}
      {!disabled && !minimized && (
        <button
          className={`mr-4 font-code lg:text-lg xl:text-xl ${
            isHovered ? "text-white" : "text-[#828282]"
          }`}
          onClick={navigateToRedirect}
          onMouseEnter={hovered}
          onMouseLeave={notHovered}
        >
          {text}
        </button>
      )}
      {!centered && (
        <button onClick={navigateToRedirect}>
          <img
            src={img}
            alt={text}
            className={`mb-2 mr-4 h-16 w-16 lg:scale-75 ${
              isHovered && disabled == false
                ? "industry-img-selected"
                : "industry-img"
            }`}
            onMouseEnter={hovered}
            onMouseLeave={notHovered}
          />
        </button>
      )}
    </div>
  );
};

export default SidebarElement;
